const error = {
  state: {
    clientErrors: null,
  },
  getters: {
    clientErrors(state) { return state.clientErrors },
  },
  mutations: {
    setClientErrors (state, value) {
      state.clientErrors = value
    },
  },
  actions: {},
  modules: {}
}
export default error